import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import {
  InsuranceClaimModel,
  InsuranceClaimStatusHistoryModel,
} from '../../../../../../shared/store/insurance-claim/types';
import { InsuranceClaimService } from '../../../../../../shared/store/insurance-claim/insurance-claim.service';
import { SubHeaderService } from '../../../../../../shared/store/subheader/subheader.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../../../../shared/service/modal.service';
import { filterTrue } from '../../../../../../shared/pipe/rxjs/operators';
import { take } from 'rxjs/operators';
import { ModalContentComponent } from '../../../../../../shared/components/modal-content/modal-content.component';
import { ActionButton } from '../../../../../../shared/components/modal-content/action-button';
import { toFirstLetterLower } from '../../../../../../shared/helper/stringhelper';
import { SourceEnum } from '../../../../../../shared/store/typeahead/types';
import { ModalComponentKey } from 'src/app/shared/service/modal-component';

@UntilDestroy()
@Component({
  selector: 'app-insurance-claim-details-status-histories',
  standalone: false,
  templateUrl: './insurance-claim-details-status-histories.component.html',
  styleUrl: './insurance-claim-details-status-histories.component.scss',
})
export class InsuranceClaimDetailsStatusHistoriesComponent
  implements OnInit, OnDestroy
{
  insuranceClaimModel$: Observable<InsuranceClaimModel>;
  rowData: InsuranceClaimStatusHistoryModel;

  constructor(
    private readonly insuranceClaimService: InsuranceClaimService,
    private readonly subHeaderService: SubHeaderService,
    private readonly modalService: NgbModal,
    private readonly modalExchangeService: ModalService,
  ) {
    this.insuranceClaimModel$ = this.insuranceClaimService.getByUniqueId.value$;
  }

  ngOnInit(): void {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'insuranceClaimStatusHistoryDelete') {
          this.onDelete();
        }
        if (x == 'insuranceClaimStatusHistoryEdit') {
          this.onOpenModalEdit();
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  onGetRowData() {
    //copy the data
    const result = this.rowData;

    //when we get the data, reset the data
    this.onSetRowData(undefined);

    //return the copy of the data
    return result;
  }

  onSetRowData(rowData: any) {
    this.rowData = rowData;
  }

  private onDelete() {
    const insuranceClaimStatusHistoryModel: InsuranceClaimStatusHistoryModel =
      this.onGetRowData();

    let result$ = this.insuranceClaimService.deleteStatusHistory.call({
      insuranceClaimId: insuranceClaimStatusHistoryModel.insuranceClaimId,
      insuranceClaimStatusHistoryId: insuranceClaimStatusHistoryModel.id,
    });

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.insuranceClaimService.deleteStatusHistory.reset();
    });
  }

  private onOpenModalEdit() {
    const insuranceClaimStatusHistoryModel: InsuranceClaimStatusHistoryModel =
      this.onGetRowData();

    const modalRef = this.modalService.open(ModalContentComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.componentInstance.component =
      this.modalExchangeService.getComponentClass(
        ModalComponentKey.InsuranceClaimStatusHistoryEdit,
      );
    modalRef.componentInstance.title =
      'INSURANCE_CLAIM_STATUS_HISTORY_LBL_TITLE';
    modalRef.componentInstance.cancelButton = true;
    modalRef.componentInstance.buttons = [
      <ActionButton>{
        actionName:
          toFirstLetterLower('insuranceClaimStatusHistory') + 'Update',
      },
    ];
    modalRef.componentInstance.inputParams = {
      source: SourceEnum.Modal,
      insuranceClaimId: insuranceClaimStatusHistoryModel.insuranceClaimId,
      insuranceClaimStatusHistoryId: insuranceClaimStatusHistoryModel.id,
    };

    modalRef.result
      .then((id) => {
        if (id >= 0) {
          modalRef.close();
        }
      })
      .finally(() => {
        //avoid error on cancel
      });
  }

  ngOnDestroy(): void {
    this.insuranceClaimService.deleteStatusHistory.reset();
  }
}
